/* eslint-disable no-console */

import { register } from "register-service-worker";

let latestRegistration = null;

function showUpdateNotification(registration) {
  latestRegistration = registration;

  // If banner already exists, just update the registration reference
  if (document.getElementById("sw-update-banner")) {
    return;
  }

  // DOM-based banner — fires before Vue may be interactive
  const banner = document.createElement("div");
  banner.id = "sw-update-banner";
  banner.style.cssText =
    "position:fixed;top:0;left:0;right:0;z-index:99999;display:flex;" +
    "align-items:center;justify-content:center;gap:12px;padding:14px 20px;" +
    "background:#1d5d8e;color:#fff;font-family:-apple-system,BlinkMacSystemFont," +
    "'Segoe UI',Roboto,'Noto Sans Thai',sans-serif;font-size:14px;box-shadow:0 2px 8px rgba(0,0,0,.25);";

  const msg = document.createElement("span");
  msg.textContent = "\u0E21\u0E35\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19"; // มีเวอร์ชันใหม่พร้อมใช้งาน

  const btnStyle =
    "border:none;border-radius:4px;padding:6px 16px;font-size:14px;cursor:pointer;";

  const updateBtn = document.createElement("button");
  updateBtn.textContent = "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E40\u0E25\u0E22"; // อัปเดตเลย
  updateBtn.style.cssText = btnStyle + "background:#fff;color:#1d5d8e;font-weight:600;";
  updateBtn.addEventListener("click", function () {
    // Reload only after the new service worker takes control
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", function () {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    if (latestRegistration && latestRegistration.waiting) {
      latestRegistration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  });

  const dismissBtn = document.createElement("button");
  dismissBtn.textContent = "\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07"; // ภายหลัง
  dismissBtn.style.cssText = btnStyle + "background:transparent;color:#fff;border:1px solid rgba(255,255,255,.5);";
  dismissBtn.addEventListener("click", function () {
    banner.remove();
  });

  banner.appendChild(msg);
  banner.appendChild(updateBtn);
  banner.appendChild(dismissBtn);
  document.body.appendChild(banner);
}

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(registration) {
      console.log("[SW] App is served from cache by a service worker.");
      // Check for updates every 30 minutes
      setInterval(
        function () {
          console.log("[SW] Checking for service worker update...");
          registration.update();
        },
        30 * 60 * 1000
      );
    },
    registered(registration) {
      console.log("[SW] Service worker has been registered.", registration);
    },
    cached() {
      console.log("[SW] Content has been cached for offline use.");
    },
    updatefound() {
      console.log("[SW] New content is downloading...");
    },
    updated(registration) {
      console.log("[SW] New content is available; showing update banner.");
      showUpdateNotification(registration);
    },
    offline() {
      console.log(
        "[SW] No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("[SW] Error during service worker registration:", error);
    }
  });
}
